import "./About.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faGem, faRocket } from "@fortawesome/free-solid-svg-icons";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import { motion } from "framer-motion";

import image1 from "../../../Assets/images/img13.svg";
import image2 from "../../../Assets/images/img14.svg";

const About = () => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  return (
    <div className="about-section">
      <div className="about-first">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <div className="about-title">
                <motion.div
                  initial={{ opacity: 0, x: -100 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.99, ease: "easeOut", delay: 0.2 }}
                  viewport={{ once: true }}
                >
                  <h2>About Us</h2>
                </motion.div>
                <motion.div
                  initial={{ opacity: 0, x: -100 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
                  viewport={{ once: true }}
                >
                  <h4>Shaping the world of things to come</h4>
                </motion.div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="about-content1">
                <motion.div
                  initial={{ opacity: 0, x: 100 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.99, ease: "easeOut", delay: 0.2 }}
                  viewport={{ once: true }}
                >
                  <h5>
                    Aron Engineering is a Nepal based engineering design firm,
                  </h5>
                  <p>
                    which mainly caters to structural design of components,
                    drafting, modelling and rendering of structures. Regardless
                    of complexity or scale, our dynamic team's professional
                    standards, technical excellence, safe, innovative and
                    sustainable engineering solutions are crafted to empower
                    your challenging projects.
                  </p>
                </motion.div>
              </div>

              <div className="about-content2">
                <div className="row">
                  <div className="col-md-6">
                    <motion.div
                      initial={{ opacity: 0, y: 100 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      transition={{
                        duration: 0.99,
                        ease: "easeOut",
                        delay: 0.2,
                      }}
                      viewport={{ once: true }}
                    >
                      <h3>
                        <FontAwesomeIcon icon={faGem} /> Our Vision
                      </h3>
                      <p>
                        To build a globally recognized engineering company that
                        creates opportunities and leads across diverse
                        engineering fields.
                      </p>
                    </motion.div>
                  </div>
                  <div className="col-md-6">
                    <motion.div
                      initial={{ opacity: 0, y: 100 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      transition={{
                        duration: 0.99,
                        ease: "easeOut",
                        delay: 0.3,
                      }}
                      viewport={{ once: true }}
                    >
                      <h3>
                        <FontAwesomeIcon icon={faRocket} /> Our Mission
                      </h3>
                      <p>
                        We strive to deliver client-focused solutions, promote
                        collaboration and build global partnerships that drive
                        innovation and growth.
                      </p>
                    </motion.div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="about-second">
        <div className="container">
          <div className="row d-flex align-items-center g-4">
            {/* Left Side Image */}
            <div className="col-md-6">
              <div className="about-img1">
                <img
                  src={image1}
                  alt="building"
                  className="img-fluid rounded-start"
                />
              </div>
            </div>

            {/* Right Side Cards */}
            <div className="right-side-cards col-md-6">
              <div className="row g-3 about-cards">
                <div className="col-md-6">
                  <div className="about-card red" ref={ref}>
                    <p className="card-label">GLOBAL REACH</p>
                    <h2 className="card-value">
                      <span className="countup-number">
                        {inView && <CountUp end={150} duration={5} />}
                      </span>
                      <span className="sign">+</span>
                    </h2>
                    <p className="card-desc">Clients</p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="about-card red" ref={ref}>
                    <p className="card-label">LOCAL EXPERTISE</p>
                    <h2 className="card-value">
                      <span className="countup-number">
                        {inView && <CountUp end={15} duration={5} />}
                      </span>
                      <span className="sign">+</span>
                    </h2>
                    <p className="card-desc">employees</p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="about-card red" ref={ref}>
                    <p className="card-label">OUR IMPACT</p>
                    <h2 className="card-value">
                      <span className="countup-number">
                        {inView && <CountUp end={950} duration={5} />}
                      </span>
                      <span className="sign">+</span>
                    </h2>
                    <p className="card-desc">projects done</p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="image-card">
                    <img src={image2} alt="model" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
